import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=ade7c2ea&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"
import style0 from "./MenuView.vue?vue&type=style&index=0&id=ade7c2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade7c2ea",
  null
  
)

export default component.exports